import type { Component } from "solid-js";
import {
  ProfileLayoutMainContentContainer,
  ProfileSidebarLayout,
} from "@/components/layout/ProfileLayout";
import { ProposalsTab } from "@/domains/freelance/profile/components/ProposalsTab";

export const FreelancerProposalsRoute: Component = () => {
  return (
    <ProfileSidebarLayout>
      <ProfileLayoutMainContentContainer>
        <ProposalsTab />
      </ProfileLayoutMainContentContainer>
    </ProfileSidebarLayout>
  );
};

export default FreelancerProposalsRoute;
